import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import {
  GiftKeys,
  RegularBenefitVariant,
  RegularGift,
} from '../../../../../../../typings'
import { messages } from './messages'

export function validationSuiteGift(intl: IntlShape) {
  return create(({ maxQuantity, items, type }: RegularGift) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.Gift, () => {
      test(
        GiftKeys.maxQuantity,
        $t(validation.greaterThan, { value: 0 }),
        () => {
          enforce(maxQuantity).greaterThan(0)
        }
      )
      test(GiftKeys.items, $t(validation.required), () => {
        enforce(items.length).greaterThan(0)
      })
    })
  })
}
